import { apiService } from './api';

export async function postAcknowledgment(encounterId: string): Promise<{ acknowledgmentId: string; acknowledgedAt: string }> {
  return apiService.post(`/api/v1/encounters/${encounterId}/speaker-correction-acknowledgments`, {});
}

export async function getAcknowledgment(encounterId: string): Promise<{ acknowledged: boolean; acknowledgedAt: string | null }> {
  return apiService.get(`/api/v1/encounters/${encounterId}/speaker-correction-acknowledgments`);
}
